import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { LocalesModule } from '../modelo/locales/locales.module';
import { UsuarioModule } from '../modelo/usuario/usuario.module';
import { LoginService } from '../servicios/login.service';
import * as $ from 'jquery';
import 'virtual-keyboard';


@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  clave: string;
  username: string;
  clave1: string;
  username1: string;
 idLocal:string;
 listaLocales: LocalesModule[];
  data: UsuarioModule[] = [];
  resul: UsuarioModule[];

  id: string;
  codigo: string;
  nombre: string;
  resultadoDes: string;
  rol:string;
  meail:string;
  id_pais:number;

 
  

  constructor(private permissionsService : NgxPermissionsService ,private rolesService: NgxRolesService,private api: LoginService, private ruter: Router,private alertService: AlertService) {
    
   }
  ngOnInit(): void {
    localStorage.clear();
    this.ruter.navigate(['login']);
  this.listarLocales();

  //[matKeyboard]="'numeric'" 
  }


  listarLocales()
  {
 

   this.api.localestodos()
     .subscribe((
       data: LocalesModule[]) => {
       this.listaLocales = data;
       console.log(this.listaLocales);
     },
     err =>  this.alertService.danger('Error no hay  conexion..')
     );
 
  }


  changeUsario(newValue) {
    this.username= newValue;
   
  } 

  changeClave(newValue) {
    this.clave= newValue;
   
  } 

  onKeypressUsuario(value:string){
   this.username=value;
  }

  onKeypressClave(value:string){
   this.clave=value;
  }

    puerto(){
   //   this.connectSerial();
  }

/*  async  connectSerial() {
    const log = document.getElementById('target');
      
    try {
      const port = await navigator.serial.requestPort();
      await port.open({ baudRate: 9600 });
      
      const decoder = new TextDecoderStream();
      
      port.readable.pipeTo(decoder.writable);
  
      const inputStream = decoder.readable;
      const reader = inputStream.getReader();
      
      while (true) {
        const { value, done } = await reader.read();
        if (value) {
          log.textContent += value + '\n';
        }
        if (done) {
          console.log('[readLoop] DONE', done);
          reader.releaseLock();
          break;
        }
      }
    
    } catch (error) {
      log.innerHTML = error;
    }
  }*/

  
  login() {
     
    console.log(this.username);
    this.api.validarUsuario(this.username,this.clave)
      .subscribe((
        data: UsuarioModule[]) => {
        this.resul = data;
        console.log(this.resul);
 
          this.resul.forEach(item => {
      
            this.resultadoDes='correcto';
            this.id = item.id;
            this.nombre = item.usuario;
            this.rol=item.rol;
            this.meail=item.meail;
           this.id_pais=item.id_pais;
            if (item.id_local == null){
              this.idLocal="SN";
            }else{
            this.idLocal=item.id_local.toString();
              }

        
          });
          let tipoLocal="SN"
          if (this.resultadoDes === 'correcto') {
            let rol=[];
            rol.push(this.rol);
            this.listaLocales.forEach(element => {
                if ( this.idLocal==element.id.toString()){
                   tipoLocal= element.Tipocliente_ClientesFinales;
                }
            });
            
            localStorage.setItem('tipoLocal', tipoLocal);  
              
            this.permissionsService.loadPermissions(rol);
            this.rolesService.addRole('Adminstrador', []);
            localStorage.setItem('nombre', this.nombre);
            localStorage.setItem('id', this.id);
            localStorage.setItem('local', this.idLocal.toString());  
            localStorage.setItem('rol', this.rol);  
            localStorage.setItem('meail', this.meail);  
            localStorage.setItem('id_pais', this.id_pais.toString());  
          
            this.listaLocales.forEach(item => {
              if (item.id == Number.parseInt(this.idLocal)){
                localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
              }
              
            });
      
            this.ruter.navigate(['dashboard']);
      
          } else {
           
            this.alertService.warning('Usuario o clave incorrecto..');
            }
          
      
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
   
  }
}
